import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 35vw;
	min-width: 350px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1.5rem;
`;

export const contentForm = styled.div`
	width: 100%;
	max-height: 55vh;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
`;

export const twoInputs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;

export const selectInputs = styled.div<{ $twoColunms: boolean }>`
	width: 100%;
	display: grid;
	grid-template-columns: ${(props) => (props.$twoColunms ? '1fr 1fr' : '1fr')};
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;

export const containerBtns = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		all: unset;
		width: 100%;
		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;

export const addCollections = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	> button {
		all: unset;
		width: 100%;
		padding: 1rem;
		text-align: center;
		border-radius: 5px;
		font-size: 1.4rem;
		cursor: pointer;
		background-color: ${color.system.info};
		color: ${color.interface.white};
	}
`;

export const collectionsP = styled.p`
	width: 100%;
	color: ${color.interface.lightGray};
	text-align: left;
	font-weight: 900;
`;
